/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-script-url */
/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import './tabs.css'

const Vtabs = (props: any) => {
  const [items, setItems] = useState(props.items)
  function show(event: any, ID: number, index: number) {
    const tabs = items
    tabs.map((item: any) => {
      item.isActive = 'false'
      if (ID === item.tabID) {
        item.isActive = 'true'
      }
      return item
    })
    setItems([...tabs])
    props?.onTabSelected && props?.onTabSelected(ID)
  }

  useEffect(() => {
    setItems(props.items)
  }, [props.items])

  return (
    <div className={props?.mainTabsclass ? `tabs ${props?.mainTabsclass}` : 'tabs'}>
      <div className={props?.className ? `customtabs ${props?.className}` : 'customtabs'}>
        <ul className={props?.tabsul}>
          <div
            className={
              props?.tablistclassName
                ? `customtabs-list ${props?.tablistclassName}`
                : 'customtabs-list'
            }
          >
            {items.filter((item) => {
                return item.isVisible || item.isVisible === undefined
              })

              .map((item: any, index: number) => {
                return (
                  <>
                    <li id={`vtabs-${index}`}>
                      <Link
                        className={
                          item.isActive === 'true'
                            ? props?.anchorclass
                              ? `active ${props?.anchorclass}`
                              : 'active'
                            : props?.anchorclass
                            ? `${props?.anchorclass}`
                            : ''
                        }
                        key={index}
                        onClick={(event) => show(event, item.tabID, index)}
                        tabIndex={0}
                        title={item?.title || item?.tabTitle}
                        to='#'
                      >
                        {item?.icon && <span className={item?.icon}></span>} {item?.tabTitle}{' '}
                        {props?.badge && <span className={props?.badge}>{item?.count}</span>}
                      </Link>
                    </li>
                    {item.isActive === 'true' && (
                      <div
                        className={`customtabs-content ${props?.vtabscontentclassName} ${
                          item.isActive === 'true' ? 'active' : ''
                        }`}
                        key={index}
                      >
                        <div className={props?.contentstyles}>{item?.content}</div>
                      </div>
                    )}
                  </>
                )
              })}
          </div>
          {props?.isButtons}
        </ul>
      </div>
    </div>
  )
}
export default Vtabs
